import { getCategoryHref } from '../../utils/common/category';
import {
  IDEA_GENERATOR_CATEGORY,
  BLOG_IDEA_GENERATOR_CATEGORY,
  BOOK_IDEA_GENERATOR_CATEGORY,
  BUSINESS_IDEA_GENERATOR_CATEGORY,
  CONTENT_IDEA_GENERATOR_CATEGORY,
  DRAWING_IDEA_GENERATOR_CATEGORY,
  GIFT_IDEA_GENERATOR_CATEGORY,
  PAINTING_IDEA_GENERATOR_CATEGORY,
  SIDE_HUSTLE_IDEA_GENERATOR_CATEGORY,
  STARTUP_IDEA_GENERATOR_CATEGORY,
  STORY_IDEA_GENERATOR_CATEGORY,
} from '../../constants';

const chipValues = [
  {
    title: 'All',
    value: getCategoryHref(IDEA_GENERATOR_CATEGORY),
  },
  {
    title: 'Blog',
    value: getCategoryHref(BLOG_IDEA_GENERATOR_CATEGORY),
  },
  {
    title: 'Book',
    value: getCategoryHref(BOOK_IDEA_GENERATOR_CATEGORY),
  },
  {
    title: 'Business',
    value: getCategoryHref(BUSINESS_IDEA_GENERATOR_CATEGORY),
  },
  {
    title: 'Content',
    value: getCategoryHref(CONTENT_IDEA_GENERATOR_CATEGORY),
  },
  {
    title: 'Drawing',
    value: getCategoryHref(DRAWING_IDEA_GENERATOR_CATEGORY),
  },
  {
    title: 'Gift',
    value: getCategoryHref(GIFT_IDEA_GENERATOR_CATEGORY),
  },
  {
    title: 'Painting',
    value: getCategoryHref(PAINTING_IDEA_GENERATOR_CATEGORY),
  },
  {
    title: 'Side hustle',
    value: getCategoryHref(SIDE_HUSTLE_IDEA_GENERATOR_CATEGORY),
  },
  {
    title: 'Startup',
    value: getCategoryHref(STARTUP_IDEA_GENERATOR_CATEGORY),
  },
  {
    title: 'Story',
    value: getCategoryHref(STORY_IDEA_GENERATOR_CATEGORY),
  },
];

export { chipValues };
